import * as React from 'react';
import Svg, { Path, SvgProps } from 'react-native-svg';
import { memo } from 'react';

const SvgComponent = (props: SvgProps) => (
  <Svg width="16" height="16" viewBox="0 0 16 16" fill="none" {...props}>
    <Path
      d="M6.49998 12.0005C6.36746 11.9987 6.24039 11.9474 6.14373 11.8567L2.64373 8.35672C2.564 8.25957 2.52325 8.13624 2.52942 8.01071C2.53558 7.88519 2.58822 7.76644 2.67709 7.67757C2.76595 7.58871 2.8847 7.53607 3.01023 7.52991C3.13575 7.52374 3.25908 7.56449 3.35623 7.64422L6.49998 10.7942L13.1437 4.14422C13.2409 4.06449 13.3642 4.02374 13.4897 4.02991C13.6153 4.03607 13.734 4.08871 13.8229 4.17757C13.9117 4.26644 13.9644 4.38519 13.9705 4.51071C13.9767 4.63624 13.936 4.75957 13.8562 4.85672L6.85623 11.8567C6.75957 11.9474 6.6325 11.9987 6.49998 12.0005Z"
      fill="white"
    />
  </Svg>
);

const FillCheckIcon = memo(SvgComponent);
export default FillCheckIcon;
